import { TypographyH1 } from "@/components/typography/H1";
import { TypographyP } from "@/components/typography/P";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { useLocalStorage } from "usehooks-ts";

const AppAccessDenied = () => {
  const [latestOrganizationSlug] = useLocalStorage<string | null>(
    "latestOrganizationSlug",
    null
  );

  return (
    <div
      className="w-full h-screen flex flex-col items-center justify-center"
      data-testid="accessDenied"
    >
      <TypographyH1>Access denied</TypographyH1>
      <TypographyP className="text-sm text-slate-600 font-light mt-4 max-w-[64ch] text-center mb-10">
        You do not have permission to access this application. Only organization
        members can access this page. Contact the organization owner to request
        access.
      </TypographyP>

      <Link
        to={
          latestOrganizationSlug
            ? "/organization/$organizationSlug/gallery"
            : "/organization"
        }
        params={(prev) => ({
          organizationSlug:
            latestOrganizationSlug || prev.organizationSlug || ""
        })}
      >
        <Button variant="secondary">Go back</Button>
      </Link>
    </div>
  );
};

export default AppAccessDenied;
